// extracted by mini-css-extract-plugin
export var divider = "_2x-0";
export var dividerText = "_2x-1";